import * as Sentry from '@sentry/browser';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useAuth from '../../hooks/useAuth';
import { useRefetchToken } from '../../providers/auth';
import Alert from '../../styled-components/components/Alert';
import { Button } from '../../styled-components/components/Button';
import Container from '../../styled-components/components/Container';
import Loader from '../../styled-components/components/Loader';
import { StackMedium } from '../../styled-components/components/Stack';

const NoBranchAccess = () => {
  const t = useTranslation('authentication').t;
  const [refetchToken, requestRefetchToken] = useRefetchToken();
  const { decodedToken, isAdmin, signOut } = useAuth();

  useEffect(() => {
    if (decodedToken && !isAdmin) {
      Sentry.withScope((scope) => {
        scope.clearBreadcrumbs();
        Sentry.captureMessage('User - Not assigned to any branch', {
          level: 'warning',
          extra: {
            sub: decodedToken.sub,
            belongsToBranch: decodedToken?.['belongs-to-branch'],
            marketCode: decodedToken?.['market-code'],
          },
        });
      });
    }
  }, []);

  return (
    <Container>
      <StackMedium>
        <Alert
          tone="error"
          message={t('noBranches', {
            email: decodedToken?.email,
          })}
        />
      </StackMedium>
      <StackMedium>
        <Button
          $tone="secondary"
          disabled={requestRefetchToken.isLoading}
          onClick={refetchToken}
          title={t('reloadAllClaims')}
        >
          {t('reloadAllClaims')}
          {requestRefetchToken.isLoading && <Loader inlineBlock />}
        </Button>
      </StackMedium>
      <StackMedium>
        <Button $tone="secondary" onClick={signOut} title={t('wrongMarket.signOut')}>
          {t('signOut')}
        </Button>
      </StackMedium>
    </Container>
  );
};

export default NoBranchAccess;
